LensAdvisorCustom = function() {
    this.request = function(e, t, r) {
        var n = new XMLHttpRequest;
        return n.open(e, t, !1), n.send(r), JSON.parse(n.response)
    }, this.updateCart = function(e) {
        var t = this;
        if ("theme:cart:change" !== e.type) return !1;
        this.cart = e.detail.cart, e = Array.from(new Set(this.cart.items.map((function(e) {
            return null !== e.properties && e.properties._bundleId
        }))));
        var r = !1;
        if (this.cart.items.filter((function(e) {
                return null !== e.properties && e.properties._bundleId && e.properties._apply_discount
            })), this.isProcessed()) return !1;
        (e = e.filter((function(e) {
            return e
        }))).forEach((function(e) {
            var n = t.cart.items.filter((function(t) {
                    return null !== t.properties && t.properties._bundleId === e
                })),
                i = n.find((function(e) {
                    return "frame" === e.properties._productType
                })),
                s = n.find((function(e) {
                    return "lens" === e.properties._productType || "resolved_lens" === e.properties._productType
                })),
                o = n.filter((function(e) {
                    return "addon" === e.properties._productType
                }));
            if (void 0 !== e && (void 0 === i || !1 === i.properties._unique_identifier.startsWith("frame_only"))) {
                o = void 0 === i || i.properties._addOns !== o.length;
                var u = s && i && !o ? i.quantity : 0;
                i && i.properties._lens_variant_ids && i.properties._lens_variant_ids.length !== n.filter((function(e) {
                    return "lens" === e.properties._productType || "resolved_lens" === e.properties._productType
                })).length && (u = 0), n.forEach((function(e) {
                    "resolved_lens" === e.properties._productType && (u *= 2), 0 !== u && e.quantity === i.quantity && "resolved_lens" !== e.properties._productType || (t.request("GET", "/cart/change.js?id=" + e.key + "&quantity=" + u), r = !0)
                })), localStorage.setItem("_la_cart", JSON.stringify(t.request("GET", "/cart.js")))
            }
        })), r && document.dispatchEvent(new CustomEvent("theme:cart:reload", {
            bubbles: !0
        }))
    }, this.isProcessed = function() {
        return localStorage.getItem("_la_cart") === JSON.stringify(this.cart)
    }, this.addEventListners = function() {
        document.addEventListener("theme:cart:change", LensAdvisorCustom.instance.updateCart.bind(this))
    }
}, LensAdvisorCustom.init = function() {
    LensAdvisorCustom.instance = new LensAdvisorCustom, LensAdvisorCustom.instance.addEventListners()
}, LensAdvisorCustom.init();
